/**
 * Whether what the customer typed can be the name printed on their card.
 *
 * Three checkouts carried three different floors and none of them trimmed:
 * `Payment` and `UpdatePayment` refused anything under five characters,
 * `OxfordPackages` under three, and all three accepted a field of nothing but
 * spaces. Five characters rejects real cardholders — "Ng", "Li Na", "Ari",
 * "Bob Ho" — which is the rule contradicting the field's own copy, "Enter the
 * name exactly as it appears on the card" (Track 4.9).
 *
 * Neither Stripe nor the card networks check this name against the issuer, so
 * there is nothing for a length floor to protect. Two characters after
 * trimming is enough to catch an empty field or a stray keystroke and short
 * enough to accept every name that is actually printed on a card.
 */
export const MIN_CARDHOLDER_NAME_LENGTH = 2;

export function isValidCardholderName(name?: string | null): boolean {
  return (name ?? '').trim().length >= MIN_CARDHOLDER_NAME_LENGTH;
}
